/**
 * Direct Supabase Client Export
 * ==============================
 * Provides direct access to Supabase client for queries and Realtime subscriptions
 */

import { createClient } from '@supabase/supabase-js';
import config from '../config/index';
import { Database } from '../types/database.types';

// Validate Supabase credentials
const supabaseUrl = config.supabase.url;
const supabaseAnonKey = config.supabase.anonKey;

console.log('[Supabase Client] Initializing with:', {
  url: supabaseUrl || 'MISSING',
  hasKey: !!supabaseAnonKey,
  keyLength: supabaseAnonKey?.length || 0
});

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('[Supabase Client] ERROR: Missing credentials!', {
    url: supabaseUrl,
    hasKey: !!supabaseAnonKey
  });
  throw new Error('Supabase credentials are missing. Check VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY environment variables.');
}

// Create Supabase client with Realtime enabled and full type safety
export const supabase = createClient<Database>(
  supabaseUrl,
  supabaseAnonKey,
  {
    db: {
      schema: 'public'
    },
    realtime: {
      params: {
        eventsPerSecond: 10
      }
    },
    auth: {
      persistSession: true,
      autoRefreshToken: true
    },
    global: {
      headers: {
        'X-Client-Info': 'aightbet-web'
      }
    }
  }
);

console.log('[Supabase Client] Client created successfully');

// Export for backward compatibility
export default supabase;
